import styled from "styled-components";

const StyledMain = styled.main`
width: ${(props)=> props.theme.pageWidth}
margin: 0 auto;

`

export {StyledMain}
